import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

const CONFIG = {
  success: {
    icon: CheckCircle2,
    color: "emerald",
    title: "Pagamento aprovado!",
    subtitle: "Sua assinatura UP Club está sendo ativada.",
    body: "Você vai receber a confirmação no seu WhatsApp em alguns instantes. Já pode aproveitar todos os benefícios do clube na loja.",
  },
  failure: {
    icon: XCircle,
    color: "red",
    title: "Pagamento não concluído",
    subtitle: "Algo deu errado no processamento.",
    body: "Não foi possível processar o pagamento. Você pode tentar novamente ou entrar em contato pelo WhatsApp para ajudar.",
  },
  pending: {
    icon: Clock,
    color: "amber",
    title: "Pagamento pendente",
    subtitle: "Estamos aguardando a confirmação.",
    body: "Pagamentos por boleto ou PIX podem levar alguns minutos. Assim que a operação for aprovada, sua assinatura é ativada automaticamente.",
  },
};

export default function UpClubResult({ status = "success" }) {
  const c = CONFIG[status] || CONFIG.success;
  const Icon = c.icon;
  const ring = {
    emerald: "bg-emerald-100 text-emerald-600 ring-emerald-500/20",
    red: "bg-red-100 text-red-600 ring-red-500/20",
    amber: "bg-amber-100 text-amber-600 ring-amber-500/20",
  }[c.color];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl p-8 shadow-2xl text-center" data-testid={`upclub-${status}-page`}>
        <div className={`w-20 h-20 rounded-full ${ring} ring-8 flex items-center justify-center mx-auto mb-5`}>
          <Icon size={40} />
        </div>
        <h1 className="font-display text-3xl font-bold text-slate-900 mb-2">{c.title}</h1>
        <p className="text-slate-500 text-sm mb-4">{c.subtitle}</p>
        <p className="text-slate-600 text-sm leading-relaxed mb-6">{c.body}</p>
        <div className="flex flex-col gap-2">
          <Link
            to="/catalog"
            data-testid="upclub-result-catalog"
            className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3 rounded-sm text-sm"
          >
            Voltar ao catálogo
          </Link>
          <a
            href="https://wa.me/5549998122884"
            target="_blank" rel="noreferrer"
            className="w-full border border-slate-300 text-slate-700 hover:bg-slate-50 font-medium py-2.5 rounded-sm text-sm"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
